module.exports = __webpack_public_path__ + "static/media/psychology.7a165dd4.webp";